export const environment = {
  production: false,
  base_url: 'https://oselsignage-prod.azure-api.net',
  google_maps_api_key: 'AIzaSyD5utJJSyLtmOjTZnAWcW5HRsm4VjpGNHI',
};
